import type { FC, PropsWithChildren } from "react";
import { memo } from "react";
import { StyledLayout } from "./layout.styles";
import { useLocation } from "react-router-dom";

export const ErrorLayout: FC<PropsWithChildren> = memo(({ children }) => {
  const { pathname } = useLocation();
  return (
    <StyledLayout pathname={pathname}>
      <main>{children}</main>
    </StyledLayout>
  );
});
